import React from 'react'
import { Box, Typography, Grid } from '@mui/material';
import { dataConstants } from '../../../constants';
import { colors, radii, shadows } from '../../../utils/designTokens';
import TrendingUpRoundedIcon from '@mui/icons-material/TrendingUpRounded';
import NavigateNextRoundedIcon from '@mui/icons-material/NavigateNextRounded';

const { FUNDS_SECTIONS } = dataConstants || {};

const FeaturedFundItem = ({ href, name }) => (
  <Grid item xs={12} sm={6} md={3}>
    <Box
      component="a"
      href={href}
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        textAlign: 'start',
        height: '100%',
        p: 2.5,
        borderRadius: `${radii.lg}px`,
        bgcolor: colors.neutral[0],
        border: `1px solid ${colors.neutral[200]}`,
        textDecoration: 'none',
        color: colors.neutral[900],
        boxShadow: shadows.xs,
        transition: 'all 250ms cubic-bezier(0.4, 0, 0.2, 1)',
        '&:hover': {
          borderColor: colors.accent.main,
          boxShadow: shadows.md,
          transform: 'translateY(-2px)',
          '& .icon': { color: colors.accent.main, transform: 'translateX(4px)' }
        },
        '&:focus-visible': {
          outline: `2px solid ${colors.accent.main}`,
          outlineOffset: 2,
        },
      }}
    >
      <Box>
        <Typography sx={{ fontWeight: 600, fontSize: '0.95rem', lineHeight: 1.3, mb: 0.5 }}>
          {name}
        </Typography>
        <Typography sx={{ fontSize: '0.75rem', color: colors.neutral[500], fontWeight: 500, display: 'block', }}>
          Explore Fund
        </Typography>
      </Box>
      <Box
        className="icon"
        sx={{
          display: 'flex',
          color: colors.neutral[300],
          transition: 'all 250ms ease',
        }}
      >
        <NavigateNextRoundedIcon />
      </Box>
    </Box>
  </Grid>
);

const PillFundItem = ({ href, name }) => (
  <Box
    component="a"
    href={href}
    sx={{
      display: 'inline-flex',
      alignItems: 'center',
      px: 2,
      py: 1,
      borderRadius: `${radii.pill}px`,
      bgcolor: colors.neutral[50],
      border: `1px solid ${colors.neutral[200]}`,
      textDecoration: 'none',
      color: colors.neutral[700],
      fontSize: '0.875rem',
      fontWeight: 500,
      transition: 'all 150ms ease',
      '&:hover': {
        bgcolor: colors.neutral[100],
        color: colors.neutral[900],
        borderColor: colors.neutral[300],
      },
      '&:focus-visible': {
        outline: `2px solid ${colors.accent.main}`,
        outlineOffset: 2,
      },
    }}
  >
    {name}
  </Box>
);

const PopularFunds = ({ data }) => {
  let popular_funds = data && data.length > 0 ? data.find(d => d.section_code === FUNDS_SECTIONS.FUNDS_SEARCHES) : null;
  popular_funds = popular_funds && popular_funds.tabData && popular_funds.tabData.length ? popular_funds.tabData.filter(d => d.dt != null) : null;

  if (!popular_funds || popular_funds.length === 0) return null;

  const featured = popular_funds.slice(0, 4);
  const others = popular_funds.slice(4);

  return (
    <Box sx={{ my: { xs: 4, md: 6 } }}>
      <Box
        sx={{
          bgcolor: colors.neutral[0],
          // border: `1px solid ${colors.neutral[200]}`,
          // borderRadius: `${radii.xl}px`,
          // boxShadow: shadows.sm,
          overflow: 'hidden',
          p: { xs: 1.5, sm: 4 },
          textAlign: 'center',
        }}
      >
        {/* Header Area */}
        <Box sx={{ mb: 4, display: 'flex', alignItems: 'flex-start', justifyContent: 'center', gap: 2.5 }}>
          {/* <Box
            sx={{
              display: { xs: 'none', sm: 'flex' },
              alignItems: 'center',
              justifyContent: 'center',
              width: 52,
              height: 52,
              borderRadius: `${radii.lg}px`,
              bgcolor: colors.accent[50],
              color: colors.accent.main,
              border: `1px solid ${colors.accent[100]}`,
            }}
          >
            <TrendingUpRoundedIcon sx={{ fontSize: 26 }} />
          </Box> */}
          <Box>
            <Typography
              variant="overline"
              sx={{ color: colors.accent.main, fontWeight: 700, letterSpacing: '0.08em', display: 'block', mb: 0.5 }}
            >
              Curated Directory
            </Typography>
            <Typography
              variant="h5"
              sx={{ fontWeight: 700, color: colors.neutral[900], fontSize: { xs: '1.25rem', sm: '1.5rem' }, mb: 0.5, letterSpacing: '-0.02em' }}
            >
              Popular Funds
            </Typography>
            <Typography variant="body2" sx={{ color: colors.neutral[500], fontSize: '0.95rem' }}>
              Discover top performing investment portfolios on the market right now.
            </Typography>
          </Box>
        </Box>

        {/* Featured Grid */}
        <Grid container spacing={2} sx={{ mb: others.length > 0 ? 4 : 0 }}>
          {featured.map((d, i) => (
            <FeaturedFundItem key={d.dv || i} href={d.dv} name={d.val} />
          ))}
        </Grid>

        {/* Remaining Pills */}
        {others.length > 0 && (
          <>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 2.5 }}>
              <Typography variant="subtitle2" sx={{ color: colors.neutral[400], fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.05em', fontSize: '0.75rem' }}>
                More Trending Funds
              </Typography>
              <Box sx={{ flex: 1, height: 1, bgcolor: colors.neutral[100] }} />
            </Box>
            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1.25 }}>
              {others.map((d, i) => (
                <PillFundItem key={d.dv || i} href={d.dv} name={d.val} />
              ))}
            </Box>
          </>
        )}
      </Box>
    </Box>
  );
};

export default PopularFunds
